export class ExpenseCategories {
    name: string
    description: string
    id: number
}